import customHeaders, { getSpace } from '../../../../common/headers'
import { useEffect, useState } from 'react'
import { ButtonBasic } from "@lk-gtcom/ecomlab-components"
import { CardItemAccount } from '../CardItemAccount/CardItemAccount'
import { useResponseHandler } from '../../../../common/auth'
import useGeneralStore from '../../../../store/general'
import { ModalComponent } from '../../ModalComponent/ModalComponent'
import './ModalAddAccountWebmaster.scss'

const ModalAddAccountWebmaster = ({
    setIsModal,
    currentWiki
}) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const [accountList, setAccountList] = useState([])
    const [selected, setSelected] = useState(null)

    // Получение всех аккаунтов Yandex Webmaster этом пространстве
    const fetchGetWebmaster = (id) => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/webmaster_accounts`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then(json => setAccountList(json))
            .catch(handleRequestError)
    }

    // ID аккаунта webmaster
    const fetchBindWebmaster = (id) => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/wiki_webmaster`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            webmaster_id: parseInt(id) || null
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(handleTableResponse)
            .then(json => console.log(`ID аккаунта ${json}`))
            .catch(handleRequestError)
    }

    useEffect(() => {
        fetchGetWebmaster()
    }, []);


    return (
        <ModalComponent
            title={'Добавить аккаунт Yandex Webmaster'}
            onClose={() => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '600px'
            }}
            child={
                <div className='modal-add-account-webmaster'>
                    <div className='modal-add-account-webmaster__content'>
                        {accountList?.map(({ id, name }) => {
                            return <CardItemAccount
                                id={id}
                                name={name}
                                selected={selected}
                                setSelected={setSelected}
                            />
                        })}
                    </div>
                    <ButtonBasic
                        disabled={!selected}
                        text='Выбрать'
                        onClick={(e) => {
                            fetchBindWebmaster(selected)
                            setIsModal(false)
                        }}
                    />
                </div>
            }
        />
    )
}

export { ModalAddAccountWebmaster }